import React from 'react';
import Layout from '../Layout';

const FlatButtonView = (props) => (
  <Layout {...props} type="FlatButtonView"/>
)
export default FlatButtonView;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/FlatButtonView.js